import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'input[onlyNumber]'
})
export class OnlyNumberDirective {

  constructor() { }  
  
  @HostListener('keypress', ['$event']) onInputChange(e:any) {
    var verified = String.fromCharCode(e.which).match(/[^0-9]/g);
    if (verified) {
      e.preventDefault();
      return false;
    }
    return true;
  }
}